import React from "react";
import { NotificationIcon, ViewSite } from "../admin/src/components/common/SvgIcon";

const DashboardHeader = ({
  title = "Dashboard",
  viewSiteUrl,
  notificationCount = 0,
}) => {
  return (
    <div className="w-full border-b border-gray-200 bg-white">
      <div className="mx-auto flex h-[64px] max-w-[calc(100%-32px)] items-center justify-between px-5">
        <h2 className="!text-[17px] !font-semibold z-50 !text-[#17171C]">
          {title}
        </h2>

        <div className="flex items-center gap-4">
          <button
            type="button"
            className="relative rounded-full p-1 text-gray-500 hover:text-gray-700"
          >
            <NotificationIcon />

            {notificationCount > 0 && (
              <span className="absolute -top-1 -right-1 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-indigo-600 px-1 text-[10px] font-semibold text-white">
                {notificationCount}
              </span>
            )}
          </button>

          {/* View Site */}
          {viewSiteUrl && (
            <a
              href={viewSiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-sm font-normal text-[#6F6F7B] hover:text-gray-900"
            >
              View Site
              <ViewSite />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;